<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'TITLE-OPERATIONAL-SLING-CHECK' | translate}}</span>
        <div class="header-buttons">
            <button class="fab-button primary" pTooltip="Saída por Terra" tooltipPosition="bottom" appHideMobile
                (click)="openLandExitModal()">
                <i class="pi pi-arrow-up rotate-45"></i>
            </button>
<!--            <button class="fab-button danger" (click)="openModalUserInfo()" pTooltip="Informações"-->
<!--                tooltipPosition="bottom" appHideMobile>-->
<!--                <fa-icon [icon]="'address-card'" style="font-size: 18px;"></fa-icon>-->
<!--            </button>-->
<!--            <button class="fab-button primary" [routerLink]="['/sling-totem']" pTooltip="Lingadas"-->
<!--                tooltipPosition="bottom" appHideMobile>-->
<!--                <fa-icon [icon]="'ship'" style="font-size: 18px;"></fa-icon>-->
<!--            </button>-->
<!--            <button class="fab-button primary" [routerLink]="['/debits-totem']" pTooltip="Débitos"-->
<!--                tooltipPosition="bottom" appHideMobile>-->
<!--                <i class="pi pi-money-bill"></i>-->
<!--            </button>-->
<!--            <button class="fab-button primary" [routerLink]="['/navigation-plan-panel']" pTooltip="Plano de navegação"-->
<!--                tooltipPosition="bottom" appHideMobile>-->
<!--                <i class="pi pi-map-marker"></i>-->
<!--            </button>-->
            <!-- <button class="fab-button primary" [routerLink]="['/boat-maintenance']" pTooltip="Lavação/Giro de motor"
                tooltipPosition="bottom" appHideMobile>
                <i class="pi pi-cog"></i>
            </button> -->
            <button class="fab-button primary" [routerLink]="['/single-order']" pTooltip="Pedido avulso"
                tooltipPosition="bottom" appHideMobile>
                <i class="pi pi-shopping-cart"></i>
            </button>
            <button class="fab-button primary" (click)="reload()" pTooltip="Atualizar lista" tooltipPosition="bottom">
                <i class="pi pi-refresh"></i>
            </button>
        </div>
    </p-header>

    <p-tabView styleClass="sling-check" (onChange)="onChangeMainTab($event)" *ngIf="slingConfig"
        [activeIndex]="mainActiveIndex">
        
        <!-- Aba Principal: Filas de Descida -->
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-arrow-down"></i>
                Filas de Descida
            </ng-template>
            <p-tabView styleClass="sling-check-sub" (onChange)="onChangeSubTab($event, 'down')" 
                [activeIndex]="downActiveIndex">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="pi pi-arrow-down"></i>
                        {{ 'SLINGDOWNQUEUEGENERAL' | translate }}
                    </ng-template>
                    <app-sling-down-tab [slingConfig]="slingConfig" [isMobile]="isMobile"
                        *ngIf="enableSlingDown()"></app-sling-down-tab>
                </p-tabPanel>

                <p-tabPanel *ngFor="let item of slingConfigMultQueue; let i = index">
                    <ng-template pTemplate="header">
                        <i class="pi pi-arrow-down" [ngStyle]="{'border': '2px solid ' + item.queueColor, 'border-radius': '4px', 'padding': '4px'}"></i>
                        {{item.name}}
                    </ng-template>
                    <app-sling-down-tab [slingConfig]="slingConfig" [isMobile]="isMobile"
                        [slingQuey]="item.id"
                        *ngIf="enableSlingDownMult(i+1)"></app-sling-down-tab>
                </p-tabPanel>
            </p-tabView>
        </p-tabPanel>

        <!-- Aba Principal: Embarcações Navegando -->
        <p-tabPanel *ngIf="slingConfig?.queueControl">
            <ng-template pTemplate="header">
                <img src="assets/images/sea.png" alt="" style="height: 16px; width: auto;margin-right: 7px;">
                Embarcações Navegando
            </ng-template>
            <app-sling-water-tab [isMobile]="isMobile" [slingConfig]="slingConfig"
                *ngIf="enableSlingWater()"></app-sling-water-tab>
        </p-tabPanel>

        <!-- Aba Principal: Filas de Subida -->
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-arrow-up"></i>
                Filas de Subida
            </ng-template>
            <p-tabView styleClass="sling-check-sub" (onChange)="onChangeSubTab($event, 'up')" 
                [activeIndex]="upActiveIndex">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="pi pi-arrow-up"></i>
                        Fila geral de subida
                    </ng-template>
                    <app-sling-up-tab [isMobile]="isMobile" [slingConfig]="slingConfig" 
                        *ngIf="enableSlingUpMain()"></app-sling-up-tab>
                </p-tabPanel>
                <p-tabPanel *ngFor="let item of slingConfigMultQueueUp; let i = index">
                    <ng-template pTemplate="header">
                        <i class="pi pi-arrow-up" [ngStyle]="{'border': '2px solid ' + item.queueColor, 'border-radius': '4px', 'padding': '4px'}"></i>
                        {{item.name}}
                    </ng-template>
                    <app-sling-up-tab [isMobile]="isMobile" [slingConfig]="slingConfig" 
                        [slingQueue]="item.id" *ngIf="enableSlingUpMult(i+1)"></app-sling-up-tab>
                </p-tabPanel>
            </p-tabView>
        </p-tabPanel>
    </p-tabView>
</p-fieldset>
